<template>
  <div>
    <ClosetTileCTA
      title="New Styles are Waiting"
      description="Come back to rent new arrivals before they're gone.">
      <template #icon>
        <SvgHangerPlus
          color="#850D54"
          width="36"
          height="32"/>
      </template>
      <template #button>
        <BaseButton
          class="mt-sm"
          text="Rejoin"
          @click="beginRejoinFlow"/>
      </template>
    </ClosetTileCTA>
  </div>
</template>

<script setup>
import ClosetTileCTA from '@shared/components/ADORN/ClosetTileCTA.vue'
import SvgHangerPlus from '@shared/components/icons/SvgHangerPlus.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { useRejoinStore } from '@/stores/rejoin.js'

const { beginRejoinFlow } = useRejoinStore()

</script>
